import { useEffect, useState } from "react";
import { Container, Table, Button, Form, Row, Col } from "react-bootstrap";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import { DateFmt, GetTimeNow, TimeFmt } from "../../utils/DataUtils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import Loading from "../../components/Loading";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const Entrada = () => {
  const [access, setAccess] = useState([]);
  const [filteredAccess, setFilteredAccess] = useState([]);
  const [search, setSearch] = useState("");
  const [dataFrom, setDataFrom] = useState(dayjs());
  const [dataTo, setDataTo] = useState(dayjs());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    buscarAcessos();
  }, []);

  const buscarAcessos = async () => {
    try {
      setLoading(true);
      const { data } = await blogFetch.get("/Entry");
      setAccess(data);
      setFilteredAccess(data);
    } catch (error) {
      console.error("Erro ao buscar acessos:", error);
    } finally {
      setLoading(false);
    }
  };

  const buscarComFiltroDeData = async () => {
    const queryParams = new URLSearchParams();

    if (dayjs.isDayjs(dataFrom)) {
      queryParams.append("dataFrom", dataFrom.format("YYYYMMDD"));
    }

    if (dayjs.isDayjs(dataTo)) {
      queryParams.append("dataTo", dataTo.format("YYYYMMDD"));
    }

    try {
      setLoading(true);
      const { data } = await blogFetch.get(`/Entry/data?${queryParams.toString()}`);
      setAccess(data);
      setFilteredAccess(data);
    } catch (error) {
      console.error("Erro ao buscar com filtro de data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (value) => {
    setSearch(value);
    const term = value.trim().toLowerCase();
    const filtrado = access.filter((entry) =>
      entry?.people?.peA_Name?.toLowerCase().includes(term) ||
      entry?.people?.peA_cpf?.toLowerCase().includes(term)
    );
    setFilteredAccess(filtrado);
  };

  const fazerCheckout = async (entry) => {
    const payload = {
      ...entry,
      etR_checkoutTime: GetTimeNow(),
    };

    try {
      await blogFetch.put(`/Entry/${entry.etR_PK_idEntry}`, payload);
      await buscarAcessos();
    } catch (error) {
      console.error("Erro ao fazer check-out:", error);
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <Container fluid className="app_body py-4">
        <h3 className="fw-bold text-center mb-4">Registros de Entrada</h3>
        <Form className="mb-4"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
              e.preventDefault();
            }
          }}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Label>De:</Form.Label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  value={dataFrom}
                  onChange={(date) => setDataFrom(date)}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      fullWidth: true,
                      InputProps: {
                        style: {
                          borderRadius: 8,
                          backgroundColor: "#fff",
                          fontSize: 14,
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Col>

            <Col md={3}>
              <Form.Label>Até:</Form.Label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  value={dataTo}
                  onChange={(date) => setDataTo(date)}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      fullWidth: true,
                      InputProps: {
                        style: {
                          borderRadius: 8,
                          backgroundColor: "#fff",
                          fontSize: 14,
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Col>

            <Col md={4}>
              <Form.Label>Busca:</Form.Label>
              <Form.Control
                type="search"
                placeholder="Nome ou documento"
                value={search}
                onChange={(e) => handleFilter(e.target.value)}
              />
            </Col>

            <Col md={2} className="d-flex align-items-end">
              <Button variant="primary" className="w-100" onClick={buscarComFiltroDeData}>
                Filtrar
              </Button>
            </Col>
          </Row>
        </Form>

        <div className="table-responsive overflow-y-hidden" style={{ maxHeight: "650px", overflowX: "auto" }}>
          {!loading ? (
            <Table
              bordered
              hover
              striped
              responsive
              className="align-middle text-center"
              style={{ minWidth: "1000px" }}
            >
              <thead className="table-dark sticky-top" style={{ zIndex: 10 }}>
                <tr>
                  {[
                    "Data", "Documento", "Nome", "Placa", "Responsável",
                    "Empresa", "Entrada", "Saída", "Crachá", "CEVS",
                    "Local", "NF/Requisição", "Status"
                  ].map((col) => (
                    <th key={col} className="text-nowrap">{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredAccess.length > 0 ? (
                  filteredAccess.map((entry, idx) => {
                    const person = entry.people || {};
                    return (
                      <tr key={idx}>
                        <td>{entry.etR_data}</td>
                        <td>{person.peA_cpf || "-"}</td>
                        <td>{person.peA_Name || "-"}</td>
                        <td>{entry.etR_licensePlate || "-"}</td>
                        <td>{entry.etR_responsible || "-"}</td>
                        <td>{person.peA_company || "-"}</td>
                        <td>{TimeFmt(entry.etR_checkin)}</td>
                        <td>
                          {entry.etR_checkoutTime ? (
                            TimeFmt(entry.etR_checkoutTime)
                          ) : (
                            <CheckCircleIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                fazerCheckout(entry);
                              }}
                              style={{ cursor: "pointer", color: "#0d6efd" }}
                            />
                          )}
                        </td>
                        <td>{entry.etR_badge || "-"}</td>
                        <td>{entry.etR_typeService || "-"}</td>
                        <td>{entry.etR_local || "-"}</td>
                        <td>{entry.etR_doc || "-"}</td>
                        <td>{person.peA_statusOccurrence || "-"}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={13} className="text-muted fst-italic">
                      Nenhum registro encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Loading />
          )}
        </div>
      </Container>
    </>
  );
};
